import firebase from 'firebase';
import {auth, db, storage} from '../firebase';
import moment from "moment";

class FirebaseService {

    storage = storage
    db = db
    auth = auth
    accessToken = null

    async signInWithGoogle() {
        const auth = firebase.auth();

        const provider = new firebase.auth.GoogleAuthProvider()
        provider.setCustomParameters({prompt: 'select_account'})

        return auth.signInWithPopup(provider)
            .then((result) => {
                const user = result.user

                if (user.photoURL)
                    this.saveUserProfile(user.uid, {
                        avatarURL: user.photoURL
                    })

            }).catch((error) => {
                // const errorCode = error.code
                // const errorMessage = error.message
                // const email = error.email
                throw error
            })
    }

    async register({firstName, lastName, email, password, companyName, size, location,}) {

        // Register user
        const userData = await auth.createUserWithEmailAndPassword(email, password)
        await userData.user.sendEmailVerification()

        // Create company request
        // await this.createCompanyRequest({
        //     email,
        //     companyName,
        //     size,
        //     location
        // })

        // Create company
        // const company = await db.collection('companies').add({
        //     country: location,
        //     name,
        //     size
        // })

        // Create regular user
        await db.collection('users').doc(userData.user.uid).set({
            email,
            firstName,
            lastName
        })

        // Create business user
        await db.collection('businessUsers').doc(userData.user.uid).set({
            email,
        })

        // Create business - company association
        // await db.collection('businessUserCompany').add({
        //     userId: businessUser.id,
        //     companyId: company.id,
        // })

        return {
            user: {
                id: userData.user.uid,
                name: userData.user.displayName,
                email: userData.user.email,
                phoneNumber: userData.user.phoneNumber,
                avatar: userData.user.photoURL
            },
            // company: {
            //     name,
            //     location,
            //     size
            // }
        }
    }

    async registerWithCompany({email, password, companyName, companyId}) {

        // Register user
        const userData = await auth.createUserWithEmailAndPassword(email, password)

        // Create company request
        await this.createCompanyRequest({
            email,
            companyName,
            companyId,
            requestedAt: new Date()
        })

        // Find company
        // const company = await this.getCompany(companyId)

        // Create business user
        // const businessUser = await db.collection('businessUsers').add({
        //     id: userData.user.uid,
        //     email,
        // })

        // Create business - company association
        // await db.collection('businessUserCompany').add({
        //     userId: businessUser.id,
        //     companyId: company.id,
        // })

        return {
            user: {
                id: userData.uid,
                name: userData.displayName,
                email: userData.email,
                phoneNumber: userData.phoneNumber,
                avatar: userData.photoURL
            },
            // company
        }
    }

    async login({email, password}) {
        // Sign in user
        const userData = await auth.signInWithEmailAndPassword(email, password)

        // Check if user has a business account / he might have registered from app
        const businessUserAccount = await db.collection('businessUsers')
            .doc(userData.user.uid)
            .get()

        if (!businessUserAccount.exists)
            await db.collection('businessUsers')
                .doc(userData.user.uid)
                .set({
                    email: userData.user.email,
                })

        const token = await userData.user.getIdTokenResult()
        const stripeRole = token.claims.stripeRole

        // Fetch user company
        const companies = await this.getCompanies(userData.user.uid)
        const companyRequest = await this.getCompanyRequest(userData.user.email)

        const company = companies.length > 0 ? companies[0] : null

        if (!userData.subscription && companies.length > 0) {
            const invoices = await this.getInvoices(company.id)

            if (invoices.length > 0) {

                const invoice = invoices[0]
                // if (invoice.paid) userData.user.subscription = invoice.package.role
                if (invoice.stripeInvoiceStatus) userData.user.subscription = invoice.package.role
                userData.user.tracker = 'invoice'
            }
        }

        const user = {
            id: userData.user.uid,
            name: userData.user.displayName,
            email: userData.user.email,
            phoneNumber: userData.user.phoneNumber,
            avatar: userData.user.photoURL,
            subscription: stripeRole,
            tracker: stripeRole ? 'stripe' : null,
        }

        if (company) {
            const now = new Date()
            const freeTrial = company.freeTrial ? company.freeTrial.toDate() : null
            if (freeTrial && freeTrial > now) {
                const duration = moment.duration(moment(company.freeTrial.toDate()).diff(moment()))

                user.tracker = 'trial'
                user.freeTrialUntil = moment(company.freeTrial.toDate()).format('DD-MM-YYYY')
                user.freeTrialDiff = duration.asDays()
            }
        }

        user.companyRequest = !!companyRequest

        return {
            user,
            company
        }
    }

    async getUserSubscriptions(id) {
        const subs = await db.collection('businessUsers')
            .doc(id)
            .collection('subscriptions')
            .orderBy('created', 'desc')
            // .where('status', 'in', ['trialing', 'active', 'canceled'])
            .get()

        return subs.docs ? Promise.all(subs.docs
            .filter(doc => doc.exists)
            .map(async doc => {
                return {
                    id: doc.id, ...doc.data()
                }
            })) : []
    }

    async getSubscriptionPackages() {

        const compare = (a, b) => {
            if (a.price.unit_amount < b.price.unit_amount) {
                return -1;
            }
            if (a.price.unit_amount > b.price.unit_amount) {
                return 1;
            }
            return 0;
        }

        const packages = await db.collection('packages')
            .where('active', '==', true)
            .get()

        return (await Promise.all(packages.docs
            .filter(doc => doc.exists)
            .map(async doc => {
                const price = await doc.ref.collection('prices')
                    .get()

                return {
                    id: doc.id, ...doc.data(), price: price.docs.filter(doc => doc.exists).map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })[0]
                }
            }))).sort(compare)
    }

    async getUserProfile(id) {
        const userProfile = await db.collection('users')
            .doc(id)
            .get()

        return userProfile.exists ? {id: userProfile.id, ...userProfile.data()} : null
    }

    async saveUserProfile(id, data) {
        const userProfile = await db.collection('users')
            .doc(id)
            .get()

        return userProfile.exists ?
            await db.collection('users').doc(id).update(data) :
            await db.collection('users').doc(id).set(data)
    }


    async autoLoginTest(user) {
        // const userData = await this.currentUser()

        const token = await user.getIdTokenResult()
        const stripeRole = token.claims.stripeRole
        const role = token.claims.role

        const userProfile = await this.getUserProfile(user.uid)

        const userData = {
            id: user.uid,
            name: user.displayName,
            email: user.email,
            phoneNumber: user.phoneNumber,
            // avatar: user.photoURL,
            subscription: stripeRole,
            emailVerified: user.emailVerified,
            tracker: stripeRole ? 'stripe' : null,
            avatar: userProfile ? userProfile.avatarURL : null,
            firstName: userProfile ? userProfile.firstName : null,
            lastName: userProfile ? userProfile.lastName : null,
            role
        }

        const companies = await this.getCompanies(userData.id)
        const companyRequest = await this.getCompanyRequest(userData.email)
        const companyAccessRequest = await this.getUserCompanyAccessRequest(userData.id)

        const company = companies.length > 0 ? companies[0] : null

        if (!userData.subscription && companies.length > 0) {
            const invoices = await this.getInvoices(company.id)

            if (invoices.length > 0) {

                const invoice = invoices[0]
                if (invoice.stripeInvoiceStatus === 'paid') userData.subscription = invoice.package.role
                userData.tracker = 'invoice'
            }
        }

        if (company) {
            const now = new Date()
            const freeTrial = company.freeTrial ? company.freeTrial.toDate() : null
            if (freeTrial && freeTrial > now) {
                const duration = moment.duration(moment(company.freeTrial.toDate()).diff(moment()))

                userData.tracker = 'trial'
                userData.freeTrialUntil = moment(company.freeTrial.toDate()).format('DD-MM-YYYY')
                userData.freeTrialDiff = duration.asDays()
            }
        }

        userData.companyRequest = companyRequest
        userData.companyAccessRequest = companyAccessRequest

        return {
            user: userData,
            company,
        }
    }

    async autoLogin() {

        const userData = await this.currentUser()
        const companies = await this.getCompanies(userData.id)
        const companyRequest = await this.getCompanyRequest(userData.email)
        const companyAccessRequest = await this.getUserCompanyAccessRequest(userData.id)

        const company = companies.length > 0 ? companies[0] : null
        const userProfile = await this.getUserProfile(userData.id)

        userData.avatar = userProfile ? userProfile.avatarURL : null
        userData.firstName = userProfile ? userProfile.firstName : null
        userData.lastName = userProfile ? userProfile.lastName : null

        if (!userData.subscription && companies.length > 0) {
            const invoices = await this.getInvoices(company.id)

            if (invoices.length > 0) {

                const invoice = invoices[0]
                if (invoice.stripeInvoiceStatus === 'paid') userData.subscription = invoice.package.role
                userData.tracker = 'invoice'
            }
        }

        if (company) {
            const now = new Date()
            const freeTrial = company.freeTrial ? company.freeTrial.toDate() : null
            if (freeTrial && freeTrial > now) {
                const duration = moment.duration(moment(company.freeTrial.toDate()).diff(moment()))

                userData.tracker = 'trial'
                userData.freeTrialUntil = moment(company.freeTrial.toDate()).format('DD-MM-YYYY')
                userData.freeTrialDiff = duration.asDays()
            }
        }

        userData.companyRequest = companyRequest
        userData.companyAccessRequest = companyAccessRequest

        return {
            user: userData,
            company,
        }
    }

    async createCompanyAccessRequest(data) {
        await db.collection('companyAccessRequests').add(data)
    }

    async declineCompanyAccessRequest(id) {
        await db.collection('companyAccessRequests').doc(id).delete()
    }

    async getBusinessUserAccount(email) {
        const businessUsers = await db
            .collection(`businessUsers`)
            .where('email', '==', email)
            .get()

        return businessUsers.docs
            .filter(doc => doc.exists)
            .map(doc => {
                return {id: doc.id, ...doc.data()}
            })
    }

    async acceptCompanyAccessRequest({companyId, id, userId}) {
        await db.collection('businessUserCompany').add({
            userId: userId,
            companyId: companyId,
            role: 'member',
            createdAt: new Date()
        })

        return await db.collection('companyAccessRequests').doc(id).update({
            completed: true
        })
    }

    async getUserCompanyAccessRequest(userId) {
        const requests = await db
            .collection(`companyAccessRequests`)
            .where('userId', "==", userId)
            .where('completed', "==", false)
            .get()

        return requests.docs
            .filter(doc => doc.exists)
            .map(doc => {
                return {id: doc.id, ...doc.data()}
            })
    }

    async getCompanyAccessRequests(companyId) {
        const requests = await db
            .collection(`companyAccessRequests`)
            .where('companyId', "==", companyId)
            .where('completed', "==", false)
            .get()

        return Promise.all(requests.docs
            .filter(doc => doc.exists)
            .map(async doc => {
                const user = await this.getUserProfile(doc.data().userId)
                return {id: doc.id, ...doc.data(), profile: user}
            }))
    }

    async getCompanyEmployees(companyId, userId) {
        const pivots = await db
            .collection(`businessUserCompany`)
            .where('userId', '!=', userId)
            .where('companyId', '==', companyId)
            .get()

        if (pivots.empty) return []

        const businessUserCompanyIds = pivots.docs
            .filter(doc => doc.exists)
            .map(doc => {
                return {id: doc.id, ...doc.data()}
            })

        return await Promise.all(businessUserCompanyIds
            .map(async doc => {
                const businessUser = await db
                    .collection(`businessUsers`)
                    .doc(doc.userId)
                    .get()

                const user = await this.getUserProfile(doc.userId)

                if (businessUser.exists)
                    return {
                        id: businessUser.id,
                        businessUserCompanyId: doc.id, ...businessUser.data(),
                        joinedAt: doc.createdAt,
                        role: doc.role,
                        profile: user
                    }
            }))
    }

    async updateCompanyEmployeeRole(id, role) {
        await db.collection('businessUserCompany').doc(id).update({
            role
        })
    }

    async getCompanyEmployeesAll(companyId) {
        const pivots = await db
            .collection(`businessUserCompany`)
            .where('companyId', '==', companyId)
            .get()

        if (pivots.empty) return []

        const businessUserCompanyIds = pivots.docs
            .filter(doc => doc.exists)
            .map(doc => doc.data())

        return await Promise.all(businessUserCompanyIds
            .map(async doc => {
                const businessUser = await db
                    .collection(`businessUsers`)
                    .doc(doc.userId)
                    .get()

                if (businessUser.exists)
                    return {
                        id: businessUser.id, ...businessUser.data(), role: doc.role
                    }
            }))
    }

    async removeCompanyEmployee(employee, companyId) {
        // Remove business user company
        const businessUserCompany = await db.collection('businessUserCompany')
            .where('companyId', '==', companyId)
            .where('userId', '==', employee.id)
            .get()

        if (businessUserCompany.empty) return []

        const userDocs = businessUserCompany.docs
            .filter(doc => doc.exists)
            .map(doc => {
                return {id: doc.id, ...doc.data()}
            })

        await db.collection('businessUserCompany').doc(userDocs[0].id).delete()

        // Remove company access request
        const accessRequests = await db.collection('companyAccessRequests')
            .where('companyId', '==', companyId)
            .where('userId', '==', employee.id)
            .get()

        if (accessRequests.empty) return []

        const requestDocs = accessRequests.docs
            .filter(doc => doc.exists)
            .map(doc => {
                return {id: doc.id, ...doc.data()}
            })

        await db.collection('companyAccessRequests').doc(requestDocs[0].id).delete()
    }

    async getFeaturedEvents() {
        const featuredEvents = await db
            .collection('featuredEvents')
            .get()

        return await Promise.all(featuredEvents.docs
            .filter(doc => doc.exists)
            .map(async doc => {
                const event = await this.getEvent(doc.id)
                return {id: doc.id, ...doc.data(), ...{company: event.company.name, title: event.title}}
            }))
    }

    async setFeaturedEvent(id, data) {
        await db.collection('featuredEvents').doc(id).set(data)
    }

    async removeFeaturedEvent(id) {
        return await db.collection('featuredEvents').doc(id).delete()
    }

    async currentUser() {
        return new Promise((resolve, reject) => {
            auth.onAuthStateChanged(async user => {
                if (user) {

                    const token = await user.getIdTokenResult()

                    console.log(token.token)
                    this.accessToken = token.token

                    const stripeRole = token.claims.stripeRole
                    const role = token.claims.role

                    resolve({
                        id: user.uid,
                        name: user.displayName,
                        email: user.email,
                        phoneNumber: user.phoneNumber,
                        avatar: user.photoURL,
                        emailVerified: user.emailVerified,
                        subscription: stripeRole,
                        tracker: stripeRole ? 'stripe' : null,
                        role
                    })
                } else {
                    reject('Error')
                }
            })
        })
    }

    async createCompanyRequest(data) {

        if (!data.companyId) return await db.collection('companyRequests').add(data)

        const admin = await db.collection('businessUserCompany')
            .where('companyId', '==', data.companyId)
            .where('role', '==', 'admin')
            .get()

        if (!admin.empty) {
            const previousRequest = await db.collection('companyAccessRequests')
                .where('companyId', '==', data.companyId)
                .where('userId', '==', data.userId)
                .get()

            if (!previousRequest.empty) return

            return await db.collection('companyAccessRequests')
                .add({
                    requestedAt: new Date(),
                    companyId: data.companyId,
                    companyName: data.companyName,
                    completed: false,
                    email: data.email,
                    userId: data.userId,
                    createdAt: new Date()
                })
        }

        return await db.collection('companyRequests').add(data)
    }

    async createInvitationEmail() {

    }

    async confirmCompanyAdminRequest(data) {
        await db.collection('businessUserCompany').add(data)
    }

    async completeCompanyRequest(id) {
        return await db.collection('companyRequests').doc(id).update({
            completed: true
        })
    }

    async deleteCompanyRequest(id) {
        return await db.collection('companyRequests').doc(id).delete()
    }

    async sendNotification(data) {
        return await db.collection('notifications').add(data)
    }

    async logout() {
        return await auth.signOut()
    }

    // async setDateOnCompanyRequests() {
    //     const companyRequest = await db.collection('companyRequests')
    //         .where('completed', '==', false)
    //         .get()
    //
    //     const allRequests = companyRequest.docs
    //         .filter(doc => doc.exists)
    //         .map(doc => {
    //
    //             return {id: doc.id, ...doc.data()}
    //         })

        // const parsed = allRequests.filter(rec => !rec.requestedAt)

        // parsed.map(doc => {
        //     console.log(doc.id)
        //     db.collection('companyRequests').doc(doc.id).update({ requestedAt: new Date() })
        // })
        // return parsed
    // }

    async getCompanyRequest(email) {
        const companyRequest = await db
            .collection(`companyRequests`)
            .where('email', "==", email)
            .get()

        if (companyRequest.empty) return null

        return companyRequest.docs
            .filter(doc => doc.exists)
            .map(doc => {
                return {id: doc.id, ...doc.data()}
            })
    }

    async getCompanyRequestsAdmin(direction = 'desc', {
        lastRequestRecordNext = null,
        lastRequestRecordPrevious = null,
        paginationDirection = 'next',
        limit = 10
    }) {

        let companyRequest = await db.collection('companyRequests')
            .where('completed', '==', false)
            .orderBy('requestedAt', direction)

        if (lastRequestRecordNext && lastRequestRecordPrevious) {
            companyRequest = paginationDirection === 'next' ?
                await companyRequest
                    .startAfter(lastRequestRecordNext)
                    .limit(limit)
                    .get() :
                await companyRequest
                    .endBefore(lastRequestRecordPrevious)
                    .limitToLast(limit)
                    .get()
        } else {
            companyRequest = await companyRequest
                .limit(limit)
                .get()
        }

        return {
            data: companyRequest.docs
                .filter(doc => doc.exists)
                .map(doc => {
                    return {id: doc.id, ...doc.data()}
                }),
            lastRecordPrevious: companyRequest.docs[0],
            lastRecordNext: companyRequest.docs[companyRequest.docs.length - 1]
        }

        // return companyRequest.docs
        //     .filter(doc => doc.exists)
        //     .map(doc => {
        //         return {id: doc.id, ...doc.data()}
        //     })
    }

    async companiesWithNoNewEvents() {
        const companies = await db.collection('companies')
            .get()

        const companiesWithEvents = await Promise.all(companies.docs
            .filter(doc => doc.exists)
            .map(async doc => {

                const date = new Date(Date.now() - 60 * 24 * 60 * 60 * 1000)

                const events = await db
                    .collection(`events`)
                    .where('company.companyID', "==", doc.id)
                    .orderBy('date', 'desc')
                    .where('date', '>', date)
                    .get()

                return {
                    id: doc.id,
                    ...doc.data(),
                    events: events.docs
                        .filter(doc => doc.exists)
                        .map(doc => {
                            return {id: doc.id, title: doc.data().title}
                        })
                }
            }))

        return companiesWithEvents.filter(company => company.events.length === 0)
    }

    async getCompanyRequestAdmin(id) {
        const companyRequest = await db.collection('companyRequests')
            .doc(id)
            .get()

        if (companyRequest.empty) return null

        const request = {id: companyRequest.id, ...companyRequest.data()}

        if (request.companyId)
            request.company = await this.getCompany(request.companyId)

        return request
    }

    async getCompanies(userId) {
        const user = await db
            .collection(`businessUsers`)
            .doc(userId)
            .get()

        if (user.empty) return []

        const pivots = await db
            .collection(`businessUserCompany`)
            .where('userId', "==", user.id)
            .get()

        if (pivots.empty) return []

        let companies = []

        if (pivots) {
            // const companyIds = pivots.docs
            //     .filter(doc => doc.exists)
            //     .map(doc => doc.data().companyId)

            const pivotData = pivots.docs
                .filter(doc => doc.exists)
                .map(doc => doc.data())

            companies = await Promise.all(pivotData
                .map(async doc => {
                    const company = await db
                        .collection(`companies`)
                        .doc(doc.companyId)
                        .get()

                    if (company.exists)
                        return {
                            id: company.id, ...company.data(), role: doc.role
                        }
                }))

            // companies = await db
            //     .collection(`companies`)
            //     .where(firebase.firestore.FieldPath.documentId(), 'in', companyIds)
            //     .get()
        }

        return companies

        // return companies.docs
        //     .filter(doc => doc.exists)
        //     .map(doc => {
        //         return {id: doc.id, ...doc.data()}
        //     })
    }

    async createCompany(data) {
        const company = await db.collection('companies')
            .where('ticker', '==', data.ticker)
            .where('country', '==', data.country)
            .get()

        if (!company.empty)
            throw new Error('Company with this ticker already exists!')

        return await db.collection('companies')
            .add(data)
    }

    async deleteCompany(id) {
        // TODO delete company events

        // TODO delete company
        return await db.collection('companies').doc(id).delete()
    }

    async getAllCompanies({lastCompanyRecordNext = null, lastCompanyRecordPrevious = null, paginationDirection = 'next', limit = 10}) {
        let companies = await db.collection('companies')

        if (lastCompanyRecordNext || lastCompanyRecordPrevious) {
            companies = paginationDirection === 'next' ?
                await companies
                    .orderBy('name', 'asc')
                    .startAfter(lastCompanyRecordNext)
                    .limit(limit)
                    .get() :
                await companies
                    .orderBy('name', 'asc')
                    .endBefore(lastCompanyRecordPrevious)
                    .limitToLast(limit)
                    .get()
        } else {
            companies = await companies
                .orderBy('name', 'asc')
                .limit(limit)
                .get()
        }

        return {
            data: companies.docs
                .filter(doc => doc.exists)
                .map(doc => {
                    return {id: doc.id, ...doc.data()}
                }),
            lastRecordNext: companies.docs[0],
            lastRecordPrevious: companies.docs[companies.docs.length - 1]
        }

    }

    async getCompaniesSearch(ids) {
        if (!ids.length) return []

        const companies = await db.collection('companies')
            .where(firebase.firestore.FieldPath.documentId(), 'in', ids)
            .get()

        return companies.docs
            .filter(doc => doc.exists)
            .map(doc => {
                return {id: doc.id, ...doc.data()}
            })
    }

    async getCompany(id) {
        const company = await db.collection('companies').doc(id).get()
        return company.exists ? {id: company.id, ...company.data()} : {}
    }

    async updateCompany(id, data) {
        const company = await db.collection('companies')
            .where('ticker', '==', data.ticker)
            .where('country', '==', data.country)
            .get()

        if (!company.empty)
            throw new Error('Company with this ticker already exists!')
        
        return await db.collection('companies').doc(id).update(data)
    }

    async getEvents(companyID) {
    // async getEvents() {
        // const companyID = 'XjqPoeDH21AStDDbDM4R'
        // const companyID = 'KYQa6R1aIrwgN4QYRgh2'
        // const companyID = 'X4hHsVgLGWEv0Hb5PORy'
        if (!companyID) return []

        const events = await db
            .collection(`events`)
            .where('company.companyID', "==", companyID)
            .orderBy('date', 'desc')
            .get()

        return events.docs
            .filter(doc => doc.exists)
            .map(doc => {
                return {id: doc.id, ...doc.data()}
            })
    }

    async getEvent(id) {
        const event = await db.collection('events').doc(id).get()
        return event.exists ? {id: event.id, ...event.data()} : {}
    }

    async createEvent(data) {
        return await db.collection('events').add(data)
    }

    async updateEvent(id, data) {
        return await db.collection('events').doc(id).update(data)
    }

    async deleteEvent(id) {
        return await db.collection('events').doc(id).delete()
    }

    async getInvoices(companyID) {
        if (!companyID) return []

        const invoices = await db
            .collection(`invoices`)
            .where('companyID', "==", companyID)
            .orderBy('createdAt', 'desc')
            .get()

        return invoices.docs
            .filter(doc => doc.exists)
            .map(doc => {
                return {id: doc.id, ...doc.data()}
            })
    }

    async cancelInvoice(id) {
        return await db.collection('invoices').doc(id).update({
            stripeInvoiceStatus: 'canceled',
            canceledAt: new Date()
        })
    }

    async createInvoiceRequest(data) {
        return await db.collection('invoiceRequests').add(data)
    }

    async createInvoice(data) {
        return await db.collection('invoices').add(data)
    }

    async newsletterSignup(email) {
        return await db.collection('newsletter').add({email, notified: false})
    }
}

export default new FirebaseService()